interface CountryHousingData {
  country: string;
  countryCode: string;
  cities: {
    [key: string]: {
      ratioNow: number;
      ratio1980: number;
      currency: string;
      avgIncome: number;
      avgDeposit: number;
    };
  };
}

// Dummy data for demonstration
export const housingData: CountryHousingData[] = [
  {
    country: "United States",
    countryCode: "US",
    cities: {
      "San Francisco": {
        ratioNow: 11,
        ratio1980: 1.2,
        currency: "USD",
        avgIncome: 120000,
        avgDeposit: 1320000
      },
      "New York": {
        ratioNow: 13,
        ratio1980: 1.5,
        currency: "USD",
        avgIncome: 95000,
        avgDeposit: 1235000
      }
    }
  },
  {
    country: "United Kingdom",
    countryCode: "GB",
    cities: {
      "London": {
        ratioNow: 14,
        ratio1980: 1.1,
        currency: "GBP",
        avgIncome: 45000,
        avgDeposit: 630000
      },
      "Manchester": {
        ratioNow: 9,
        ratio1980: 0.9,
        currency: "GBP",
        avgIncome: 35000,
        avgDeposit: 315000
      }
    }
  },
  {
    country: "Australia",
    countryCode: "AU",
    cities: {
      "Sydney": {
        ratioNow: 15,
        ratio1980: 1.3,
        currency: "AUD",
        avgIncome: 90000,
        avgDeposit: 1350000
      },
      "Melbourne": {
        ratioNow: 12,
        ratio1980: 1.1,
        currency: "AUD",
        avgIncome: 85000,
        avgDeposit: 1020000
      }
    }
  }
];

export const getLocationData = async (latitude: number, longitude: number) => {
  // In a real implementation, this would use the coordinates to determine the city
  // For now, return San Francisco as default
  return {
    country: "United States",
    city: "San Francisco",
    data: housingData[0].cities["San Francisco"]
  };
};
